import { Route, Switch, Redirect } from 'react-router-dom';

import ConnectBookingDetailsPage from './pages/BookingDetailsPage/ConnectBookingDetailsPage';
import NotFoundPage from 'pages/NotFoundPage';
import CancellationQuotePage from 'pages/CancellationQuotePage';
import ConnectBookingListPage from 'pages/BookingListPage/ConnectBookingListPage';
import ChangeDatesRequestPage from 'pages/ChangeDatesRequestPage';
import PrintViewPage from 'pages/PrintViewPage';
import ChangeDatesPage from 'pages/ChangeDatesPage';
import { BookingAccessRoute, SSORoute } from 'components/Authentication';

const Route404Page = () => <NotFoundPage />;

export default (
  <Switch>
    <Route path="/" exact render={() => <Redirect to={{ pathname: '/bookings' }} />} />
    <BookingAccessRoute path="/bookings/:bookingId/cancellation-quote/:stage?" component={CancellationQuotePage} />
    <BookingAccessRoute path="/bookings/:bookingId/change-date-request/:stage?" component={ChangeDatesRequestPage} />
    <BookingAccessRoute path="/bookings/:bookingId/change-date/:stage?" component={ChangeDatesPage} />
    <BookingAccessRoute path="/bookings/:bookingId/print" component={PrintViewPage} />
    <BookingAccessRoute path="/bookings/:bookingId" component={ConnectBookingDetailsPage} />
    <SSORoute path="/bookings" component={ConnectBookingListPage} />
    <Route path="*" component={Route404Page} />
  </Switch>
);
